import {destroyToken, retrieveToken, magasins} from "../../api/users.api"
import Echo from "laravel-echo";
import {store} from "../index";

const state = {
    token: localStorage.getItem('access_token') || null,
    user: localStorage.getItem('user') || null,
    magasins: [],
}

const mutations = {
    setToken(state, token) {
        console.log("set token " + token)
        state.token = token
        localStorage.setItem('access_token', token)

    },
    setUser(state, user) {
        state.user = user
        localStorage.setItem('user', user)
    },
    destroyToken(state) {
        localStorage.removeItem('access_token')
        state.token = null
    },
    set_magasins(state,magasins){
        state.magasins = magasins
    }
}

const actions = {

    destroyToken(context, credentials) {
        return destroyToken()
    },

    retrieveMagasins(context, credentials) {

        return new Promise((resolve, reject) =>
            magasins()
                .then((response) => {
                    if (response.status == '200')
                    {
                        context.commit('set_magasins', response.data)
                    }
                })
                .catch(error => {
                })
        )
    },

    retrieveToken(context, credentials) {
        return retrieveToken(credentials.username, credentials.password)
    }
}

const getters = {
    get_auth_user_id(state) {
        return state.user.id
    },
    loggedIn(state) {
        return state.token !== null
    }
}

export default {
    namespaced: false,
    state,
    getters,
    actions,
    mutations,
}